import { Component, OnInit, Inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastService } from "@app/components/toastr/toast.service";

@Component({
  selector: "app-course-create",
  templateUrl: "./course-create.component.html",
  styleUrls: ["./course-create.component.scss"],
})
export class CourseCreateComponent implements OnInit {
  public Form: FormGroup;
  submitted = false;
  message = null;
  class = null;
  action = null;
  streams = [];
  degree = [];
  keywords = [];

  constructor(
    private ActivatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private toast: ToastService,
    @Inject("API_ENDPOINT") private api_endpoint: string
  ) {}

  ngOnInit() {
    this.action = "Submit";
    this.ActivatedRoute.params.subscribe((params) => {
      let id = params["id"];

      this.http
        .get<any>(`${environment.apiUrl}/course/${id}`, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          (data) => {
            console.log(data);
            
            data.message == "Logged Out!"
              ? this.router.navigateByUrl("/auth/login")
              : "";
            if (data!= null) {
              this.action = "Update";
              this.Form.patchValue({
                _id:data._id,
                name:data.name,
                description:data.description,
                image:data.image,
                status:data.status,
                keywords:data.keywords,
                streams:data.streams,
                degree:data.degree,
              });
            }
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.log("Client-side error occured.");
            } else {
              console.log("Server-side error occured.");
            }
          }
        );
    });

    this.http
      .get<any>(`${environment.apiUrl}/streams/`, {
        headers: {
          Userinfo: JSON.stringify({
            _id: localStorage.getItem("adminSess"),
            role: localStorage.getItem("userRole"),
          }),
        },
      })
      .subscribe(
        (data) => {
          data.message == "Logged Out!"
            ? this.router.navigateByUrl("/auth/login")
            : "";
          this.streams = data.results;
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        }
      );
      this.http
      .get<any>(`${environment.apiUrl}/keywords/`, {
        headers: {
          Userinfo: JSON.stringify({
            _id: localStorage.getItem("adminSess"),
            role: localStorage.getItem("userRole"),
          }),
        },
      })
      .subscribe(
        (data) => {
          data.message == "Logged Out!"
            ? this.router.navigateByUrl("/auth/login")
            : "";
          this.keywords = data.results;
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        }
      );
      this.http
      .get<any>(`${environment.apiUrl}/degree/`, {
        headers: {
          Userinfo: JSON.stringify({
            _id: localStorage.getItem("adminSess"),
            role: localStorage.getItem("userRole"),
          }),
        },
      })
      .subscribe(
        (data) => {
          data.message == "Logged Out!"
            ? this.router.navigateByUrl("/auth/login")
            : "";
          this.degree = data.results;
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        }
      );

    this.Form = this.formBuilder.group({
      streams: ["", Validators.required],
      degree: ["", Validators.required],
      name: ["", Validators.required],
      description: ["", Validators.required],
      keywords: ["", Validators.required],
      image: ["", Validators.required],
      status: ["", Validators.required],
      _id: [""],
    });
  }

  get f() {
    return this.Form.controls;
  }

  onFormSubmit() {
    this.submitted = true;

    if (this.Form.invalid) {
      return;
    }

    if (this.action == "Submit") {
      let data = {
        name: this.Form.value.name,
        description: this.Form.value.description,
        image: this.Form.value.image,
        status: this.Form.value.status,
        "keywords": this.Form.value.keywords,
        "streams": this.Form.value.streams,
        "degree": this.Form.value.degree,
      };
      this.http
        .post<any>(`${environment.apiUrl}/course/`, data, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          (res) => {
            res.message == "Logged Out!"
              ? this.router.navigateByUrl("/auth/login")
              : "";
            if (res.status == "500") {
              this.message = res.message;
              this.class = "btn-primary rounded px-1 py-1";
              window.scrollTo(document.documentElement.clientWidth, 0);
              return 0;
            } else {
              this.message = "Successfully Added";
              this.class = "btn-success rounded px-1 py-1";
              this.toast.show("Successfully Added", "success");
              this.router.navigateByUrl("/course/list");
            }
          },
          (err: HttpErrorResponse) => {
            console.error("Error saving Course:", err);
            this.toast.show("Failed to save Course", "error");
          }
        );
    } else {
      let data = {
        name: this.Form.value.name,
        description: this.Form.value.description,
        image: this.Form.value.image,
        status: this.Form.value.status,
        "keywords": this.Form.value.keywords,
        "streams": this.Form.value.streams,
        "degree": this.Form.value.degree,
      };
      console.log(data);
      let id=this.Form.value._id;
      
      this.http
        .patch<any>(`${environment.apiUrl}/course/${id}`, data, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          (res) => {
            res.message == "Logged Out!"
              ? this.router.navigateByUrl("/auth/login")
              : "";
            if (res.status == "500") {
              this.message = res.message;
              this.class = "btn-primary rounded px-1 py-1";
              window.scrollTo(document.documentElement.clientWidth, 0);
              return 0;
            } else {
              this.message = "Successfully Updated";
              this.class = "btn-success rounded px-1 py-1";
              this.toast.show("Successfully Updated", "success");
              this.router.navigateByUrl("/course/list");
            }
          },
          (err: HttpErrorResponse) => {
            console.error("Error saving Course:", err);
            this.toast.show("Failed to save Course", "error");
          }
        );
    }
  }
}
